module.exports = __webpack_public_path__ + "static/media/habits-icon.ab528f6a.svg";